<template>
  <div :class="{ __disabled: disabled, opened: opened }" class="select">
    <span class="select_title">{{ getCactusString(title) }}</span>

    <i class="select_arrow"></i>
    <div @click="toggle" class="select_label">
      {{ getLabel(value) }}
      <span class="secondaryLabel" v-if="secondaryLabelKey">{{ getSecondaryLabel(value) }}</span>
    </div>
    <div v-if="opened" class="select_options">
      <div
        v-for="(o, index) in options"
        :value="getVal(value)"
        @click="change(o)"
        :class="{ __active: getVal(o) === getVal(value) }"
        class="select_option"
        :key="index"
      >
        {{ getLabel(o) }}
        <span class="secondaryLabel" v-if="secondaryLabelKey">{{ getSecondaryLabel(o) }}</span>
      </div>
    </div>
    <div v-if="opened" @click="toggle" class="select_overlay"></div>
  </div>
</template>

<script>
import expertviewMixin from './experviewMixin';

export default {
  name: 'Dropdown',
  components: {},
  mixins: [expertviewMixin],
  data() {
    return {
      opened: false
    };
  },

  props: {
    title: null,
    value: {
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    valueKey: {
      type: String,
      required: false
    },
    labelKey: {
      type: String,
      required: false
    },
    secondaryLabelKey: {
      type: String,
      required: false
    },
    onChange: {
      type: Function,
      required: false
    },
    disabled: {
      type: Boolean
    }
  },

  methods: {
    getVal(opt) {
      if (!opt) return '';
      return !this.valueKey ? opt : opt[this.valueKey];
    },
    getLabel(opt) {
      if (!opt) return '';
      const langStr = !this.labelKey ? opt : opt[this.labelKey];
      if (this.getCactusString(langStr)) {
        return this.getCactusString(langStr);
      }
      return langStr;
    },
    getSecondaryLabel(opt) {
      return !this.secondaryLabelKey ? opt : opt[this.secondaryLabelKey];
    },
    change(opt) {
      this.$emit('input', opt);
      this.opened = false;

      if (this.onChange !== undefined) {
        this.onChange(this.value);
      }
    },
    toggle() {
      if (this.disabled) {
        return;
      }
      this.opened = !this.opened;
    }
  }
};
</script>

<style scoped lang="scss">
.select {
  position: relative;

  &_title {
    color: #879baa;
    font-size: 12px;
    position: absolute;
    left: 16px;
    top: 8px;
  }

  &_arrow {
    border-style: solid;
    float: right;
    position: relative;
    top: 50%;
    margin-right: 32px;
    transform: perspective(1px) translateY(-50%);
    border-width: 6px 6px 0 6px;
    border-color: $greeny-blue transparent transparent transparent;
  }

  &_label {
    padding-left: 32px;
    width: auto;
    height: 100%;
    line-height: 60px;
    position: relative;
    text-align: left;
    top: 60%;
    transform: perspective(1px) translateY(-50%);
    color: $petrol;
    cursor: pointer;
    white-space: nowrap;

    .secondaryLabel {
      float: right;
      margin-right: 10px;
    }
  }

  &_options {
    box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
    width: 100%;
    position: absolute;
    background-color: $white;
    border: 1px solid $cloudy-blue;
    text-align: left;
    border-radius: 8px;
    z-index: 4;
    top: -1px;
    left: -1px;
  }

  &_option {
    cursor: pointer;
    height: 60px;
    white-space: nowrap;
    line-height: 60px;
    padding-left: 32px;
    text-align: left;
    color: $charcoal-grey;
    border-bottom: 1px solid $cloudy-blue;

    .secondaryLabel {
      float: right;
      margin-right: 54px;
    }

    &.__active {
      color: $greeny-blue;
    }

    &:hover {
      background: $cloudy-blue;
    }

    &:last-child {
      border-bottom: 0px;
    }
  }

  &_overlay {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 3;
    background-color: $cloudy-blue-20;
  }

  &.__disabled {
    opacity: 0.5;
  }
  &.__disabled &_label:hover {
    color: #4c4c4c;
    cursor: default;
  }
}

.dropdown-l {
  height: 72px;
  background-color: #fff;
  border: 1px solid $cloudy-blue;
  border-radius: 8px;
  font-size: 14px;
  color: $petrol;
}

.dropdown-s {
  height: 60px;
  background-color: #fff;
  border-bottom: 1px solid $cloudy-blue;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  font-size: 14px;
  color: $petrol;
}

.select.dropdown-s .select_label {
  padding-left: 12px;
  text-align: right;
  line-height: 40px;
  padding-right: 32px;
}

.select.dropdown-s .select_options {
  border-radius: 0px 0px 8px 8px;
}

.select.dropdown-s .select_option {
  height: 40px;
  line-height: 40px;
  text-align: center;
  padding-left: 0px;
}

.select.dropdown-s .select_arrow {
  margin-right: 12px;
}
</style>
